import { useEffect, useState } from 'react';
import AddImage from '../../../../reusable/images/add-image/add-image.component';
import Select from 'react-select';

import {
  Container,
  Label,
  Input,
  CheckboxRow,
  CheckboxLabel,
  CheckboxInput,
  SelectContainer
} from './image-add-section.styles';

const linkTypeOptions = [
  { value: 'external', label: 'External' },
  { value: 'internal', label: 'Internal' }
];

const internalPathOptions = [
  { value: '/login', label: 'Login' },
  { value: '/sign-up', label: 'Sign Up' },
  { value: '/shop', label: 'Shop' }
];

const positionOptions = [
  { value: 'center', label: 'Center' },
  { value: 'left', label: 'Left' },
  { value: 'right', label: 'Right' },
  { value: 'full', label: 'Full Width' }
];

const ImageAddSection = ({ onChange = () => {} }) => {
  const [image, setImage] = useState(null);
  const [position, setPosition] = useState('center');
  const [linkType, setLinkType] = useState('external');
  const [link, setLink] = useState('');
  const [linkActive, setLinkActive] = useState(false);
  const [initialized, setInitialized] = useState(false);

  const buildPayload = () => {
    const content = {
      images: image ? [{ type: 'main', position: 0 }] : []
    };

    const finalLink =
      linkType === 'external' && link && !link.startsWith('http')
        ? `https://${link}`
        : link;

    const metadata = {
      position,
      linkType,
      link: finalLink,
      linkActive
    };

    const files = image ? [{ file: image, type: 'main', position: 0 }] : [];

    return { content, metadata, files };
  };

  useEffect(() => {
    if (!initialized) {
      onChange(buildPayload());
      setInitialized(true);
    }
  }, [initialized]);

  useEffect(() => {
    if (initialized) {
      onChange(buildPayload());
    }
  }, [image, position, linkType, link, linkActive]);

  return (
    <Container>
      <Label>Upload Image</Label>
      <AddImage image={image} setImage={setImage} />

      <Label>Image Position</Label>
      <SelectContainer>
        <Select
          value={positionOptions.find(opt => opt.value === position)}
          onChange={(selected) => setPosition(selected.value)}
          options={positionOptions}
        />
      </SelectContainer>

      <Label>Link Type</Label>
      <SelectContainer>
        <Select
          value={linkTypeOptions.find(opt => opt.value === linkType)}
          onChange={(selected) => setLinkType(selected.value)}
          options={linkTypeOptions}
        />
      </SelectContainer>

      <Label>{linkType === 'external' ? 'URL' : 'Internal Path'}</Label>
      {linkType === 'external' ? (
        <Input
          value={link}
          onChange={(e) => setLink(e.target.value)}
          placeholder="https://example.com"
        />
      ) : (
        <SelectContainer>
          <Select
            value={internalPathOptions.find(opt => opt.value === link)}
            onChange={(selected) => setLink(selected.value)}
            options={internalPathOptions}
            placeholder="Select internal route..."
          />
        </SelectContainer>
      )}

      <CheckboxRow>
        <CheckboxInput
          type="checkbox"
          checked={linkActive}
          onChange={() => setLinkActive(!linkActive)}
        />
        <CheckboxLabel>Make Image a Clickable Link</CheckboxLabel>
      </CheckboxRow>
    </Container>
  );
};

export default ImageAddSection;